/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class FaceConfigurationSectionFragmentCombinationDefinitionDto {
    sectionFragmentId: string;
    flex: number | null;
    index: number;
}
